import { startsWith } from 'lodash-es';

export const isImageContentType = (contentType) =>
  startsWith(contentType, 'image/');
